import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react';
import { MenuButton } from '@/components/ui/MenuButton';
import { setMinimised, useMinimisedCount } from './minimised';

/**
 * Expand all / Collapse all, for every screen that stacks things worth folding
 * — a widget board, the lessons register, the SOP register.
 *
 * The client asked to roll a whole board up or open it out in one click rather
 * than a caret at a time. Both options are always listed — a menu whose
 * contents change as you use it is a menu you have to re-read — but each is
 * disabled when it would do nothing.
 */
export function BoardMenu({ ids, closedByDefault = false }: { ids: string[]; closedByDefault?: boolean }) {
  const collapsed = useMinimisedCount(ids, closedByDefault);

  if (ids.length === 0) return null;

  return (
    <MenuButton
      actions={[
        {
          label: 'Expand all',
          hint: 'Open everything on this screen',
          icon: ChevronsUpDown,
          disabled: collapsed === 0,
          onSelect: () => setMinimised(ids, false, closedByDefault),
        },
        {
          label: 'Collapse all',
          hint: 'Leave only the titles',
          icon: ChevronsDownUp,
          disabled: collapsed === ids.length,
          onSelect: () => setMinimised(ids, true, closedByDefault),
        },
      ]}
    />
  );
}
